var $one = function (obj, doc) {
  if (doc) {
    if (!/element/i.test(doc.toString())) {
      doc = $one(doc);
    }
    return doc.querySelector(obj);
  } else {
    return document.querySelector(obj);
  }
};
var $$ = function (obj, doc) {
  if (doc) {
    if (!/element/i.test(doc.toString())) {
      doc = $one(doc);
    }
    return doc.querySelectorAll(obj);
  } else {
    return document.querySelectorAll(obj);
  }
};

function getStyle(obj, attr) {
  return obj.currentStyle ? obj.currentStyle[attr] : getComputedStyle(obj)[attr];
}

NodeList.prototype.addEventListener = function (event, fn, useCapture) {
  this.forEach(function (element) {
    element.addEventListener(event, fn, useCapture);
  });
};
NodeList.prototype.show = function (displayType) {
  this.forEach(function (element) {
    element.style.display = displayType ? displayType : "block";
  });
};
Element.prototype.show = function (displayType) {
  this.style.display = displayType ? displayType : "block";
};
NodeList.prototype.hide = function () {
  this.forEach(function (element) {
    element.style.display = "none";
  });
};
Element.prototype.hide = function () {
  this.style.display = "none";
};

var loadFunctionArr = [];

document.addEventListener(
  "DOMContentLoaded",
  function () {
    $$("[data-copy]").addEventListener("click", function () {
      var couponVal = this.getAttribute("data-copy");
      var text = this.getAttribute("data-text");
      var btnText = this.getAttribute("data-btn");
      copyText(couponVal.trim(), text, undefined, btnText);
      this.innerHTML = btnText;
      return false;
    });

    loadFunctionArr.forEach(function (fn) {
      if (typeof fn == "function") {
        fn();
      }
    });
  },
  false
);

function copyText(val, msg, okFn, btnText) {
  var inputObj = $$("#copyTextInput");
  if (inputObj.length) {
    inputObj = inputObj[0];
    inputObj.value = val;
    inputObj.select();
    inputObj.setSelectionRange(0, inputObj.value.length), document.execCommand("Copy");
    inputObj.blur();
    var text = msg || "Copied Successfully";
    if (!btnText) {
      alert(text).okBtn(function () {
        okFn && okFn();
      });
    }
  }
}

function setFeaturedCollectionTabShow() {
  $$(".section-tabBoxB").forEach(function (element, index) {
    var span = element.querySelectorAll(".section-tabTarget-box span");
    var content = element.querySelectorAll(".section-tabBox");
    span.addEventListener("click", function (evevt) {
      var index = [].indexOf.call(span, evevt.target);
      console.log(index);
      span.forEach(function (element, ii) {
        if (ii == index) {
          element.classList.add("active");
        } else {
          element.classList.remove("active");
        }
      });
      span.forEach(function (element, ii) {
        if (ii == index) {
          element.classList.add("active");
        } else {
          element.classList.remove("active");
        }
      });
      content.forEach(function (element, ii) {
        if (ii == index) {
          element.show();
          if (element.querySelector("slide-show") && window["Flickity"]) {
            Flickity(element.querySelector("slide-show")).resize();
          }
        } else {
          element.hide();
        }
      });
    });
  });
}
setFeaturedCollectionTabShow();

/*
  product-free-gifts.liquid,
  product-card-variant-free-gifts.liquid
*/
function addToCartCompute(formDiv) {
  var parent = formDiv.closest(".product-info") || formDiv.closest("product-card");
  if (parent) {
    let data = { items: [] };
    var isFree = false;
    parent.querySelectorAll('.free-gifts__image [type="checkbox"]').forEach(function (el) {
      if (el.checked) {
        isFree = true;
        data.items.push({ quantity: 1, id: +el.dataset.variantId });
      }
    });
    if (isFree) {
      return data;
    }
    return false;
  }
  return false;
}

document.addEventListener("cart:add", (event) => {
  const data = addToCartCompute(event.detail.formDiv);
  if (data) {
    fetch("/cart/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((state) => {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .then((product) => {})
      .catch((error) => {
        //console.error('222Error:', error);
      });
  }
});

(function () {
  const enabled = document.body.dataset.countryRedirect === "true";
  if (!enabled) return;

  // 1. 定义欧盟国家代码列表 (ISO 3166-1 alpha-2)
  // 奥地利	Austria
  // 比利时	Belgium
  // 保加利亚	Bulgaria
  // 克罗地亚	Croatia
  // 塞浦路斯	Cyprus
  // 捷克	Czechia (Czech Republic)
  // 丹麦	Denmark
  // 爱沙尼亚	Estonia
  // 芬兰	Finland
  // 法国	France
  // 德国	Germany
  // 希腊	Greece
  // 匈牙利	Hungary
  // 爱尔兰	Ireland
  // 意大利	Italy
  // 拉脱维亚	Latvia
  // 立陶宛	Lithuania
  // 卢森堡	Luxembourg
  // 马耳他	Malta
  // 荷兰	Netherlands
  // 波兰	Poland
  // 葡萄牙	Portugal
  // 罗马尼亚	Romania
  // 斯洛伐克	Slovakia
  // 斯洛文尼亚	Slovenia
  // 西班牙	Spain
  // 瑞典	Sweden
  const euCountries = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE"];
  const euUrl = "https://eu.hydrofast.com/";

  if (localStorage.getItem("hide_eu_redirect")) return;

  fetch("https://ipinfo.io/json")
    .then((res) => res.json())
    .then((data) => {
      if (euCountries.includes(data.country)) {
        showRedirectModal(data.country);
      }
    })
    .catch((err) => console.error("IP fetch failed:", err));

  function showRedirectModal(countryCode) {
    // 保持你原来的 HTML 结构，只加 active 类用于动画
    const modalHtml = `
      <div id="eu-redirect-modal">
        <div class="modal-inner">
          <div style="background:#fff;padding:30px;border-radius:8px;max-width:400px;width:90%;text-align:center;box-shadow:0 4px 20px rgba(0,0,0,0.2);">
            <h3 style="margin-top:0;">Switch to EU Store?</h3>
            <p style="color:#666;line-height:1.5;">We noticed you are visiting from <strong>${countryCode}</strong>. Would you like to shop on our European store for better shipping rates?</p>
            <div style="margin-top:25px;display:flex;gap:10px;justify-content:center;">
              <button id="eu-confirm">Yes, Switch</button>
              <button id="eu-cancel">Stay Here</button>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHtml);

    // 强制重绘触发动画
    requestAnimationFrame(() => {
      document.getElementById("eu-redirect-modal").classList.add("active");
    });

    document.getElementById("eu-confirm").addEventListener("click", () => {
      window.location.href = euUrl;
    });

    document.getElementById("eu-cancel").addEventListener("click", closeModal);

    // 点击遮罩关闭
    document.getElementById("eu-redirect-modal").addEventListener("click", (e) => {
      if (e.target.id === "eu-redirect-modal") closeModal();
    });

    function closeModal() {
      const modal = document.getElementById("eu-redirect-modal");
      modal.classList.remove("active");
      setTimeout(() => {
        modal.remove();
        localStorage.setItem("hide_eu_redirect", "true");
      }, 300);
    }
  }
})();
